<template>
    <button
        v-if="type === 'button'"
        type="button"
        :class="classes"
        :style="{color, ...styles}"
        @click="$emit('click', action)"
    >
        <span>
            <IoIcon v-if="typeof icon === 'string'" :icon="icon"></IoIcon>
            <slot></slot>
        </span>
    </button>
    <button
        v-else
        type="button"
        class="io-btn link"
        :style="{color}"
        @click="$emit('click', action)"
    >
        <span>
            <slot></slot>
        </span>
    </button>
</template>

<script>
export default {
  name: 'IoButton',
  props: {
    rounded: {
      type: Boolean,
      default: true,
    },
    color: {
      type: String,
      default: 'primary',
    },
    type: {
      type: String,
      default: 'button',
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    action: {
      default: true,
    },
    icon: {
      type: [Boolean, String],
      default: false,
    },
    iconSize: {
      type: Number,
      default: 2.5,
    },
    size: {
      type: String,
      validator(value) {
        return ['', 's', 'xs'].indexOf(value) !== -1;
      },
      default: '',
    },
  },
  computed: {
    styles() {
      return {
        '--io-button-icon-height': `${this.iconSize}rem`,
        '--io-button-icon-width': `${this.iconSize}rem`,
      };
    },
    classes() {
      return {
        'io-btn btn text-primary': true,
        rounded: this.rounded,
        bordered: this.outlined,
        [`io-btn--${this.size}`]: this.size,
        icon: this.icon,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.io-btn {
    $icon-height: var(--io-button-icon-height);
    $icon-width: var(--io-button-icon-width);

    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid transparent;
    padding: 0.56rem 0.8rem;
    color: var(--primary);
    white-space: nowrap;
    font-size: 1.25rem;

    &:not([type="link"]) {
        padding: 1.032rem 0.8rem;
    }

    &.rounded {
        border-radius: 9999px !important;
    }

    &.bordered {
        border: 1px solid currentColor !important;
    }

    &.bordered:hover {
        background-color: currentColor !important;

        span {
            color: #fff;
        }
    }

    &--s:not([type="link"]) {
        padding: 0.5rem 0.8rem;
    }
    &--xs:not([type="link"]) {
        padding: 0.5rem 0.8rem;
        font-size: 1rem;
    }

    &.icon {
        padding: .5rem;
        height: $icon-height;
        width: $icon-width;
        min-height: $icon-height;
        min-width: $icon-width;
    }

    &.link {
        background-color: transparent;
        border: none;
        padding: 0;
        font-weight: 700;
    }
}
</style>
